import Vue from 'vue'
import Router from 'vue-router'
import {routerList} from './router.js'

Vue.use(Router)

export default new Router({
  routes: [
    ...routerList
  ],

})



// WEBPACK FOOTER //
// ./src/router/index.js